import { render, staticRenderFns } from "./StaffUpload.vue?vue&type=template&id=5ae3faa4&scoped=true"
import script from "./StaffUpload.vue?vue&type=script&lang=js"
export * from "./StaffUpload.vue?vue&type=script&lang=js"
import style0 from "./StaffUpload.vue?vue&type=style&index=0&id=5ae3faa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae3faa4",
  null
  
)

export default component.exports